import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { BooleanInput } from '@angular/cdk/coercion';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-button',
    templateUrl: './button-custom.component.html',
    styleUrls: ['./button-custom.component.scss'],
    imports: [CommonModule, MatMenuModule, MatButtonModule, MatIconModule, MatInputModule]
})
export class ButtonCustomComponent {
    readonly matMenuTriggerFor = input<MatMenu>();

    readonly type = input<'default' | 'line' | 'square' | 'icon' | 'white'>('default');
    readonly size = input<'normal' | 'small'>('normal');
    readonly icon = input<string>();
    readonly subtype = input<'default' | 'alt' | 'gradient'>('default');
    readonly disabled = input<BooleanInput>(false);
    readonly iconSuffix = input<BooleanInput>(false);

    readonly clicked = output<void>();
}
